var _classCallCheck = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var debug = require('debug')('webtorrent:file-stream');

var stream = require('readable-stream');
/**
 * Readable stream of a torrent file
 *
 * @param {File} file
 * @param {Object} opts
 * @param {number} opts.start stream slice of file, starting from this byte (inclusive)
 * @param {number} opts.end stream slice of file, ending with this byte (inclusive)
 */


var FileStream = /*#__PURE__*/function (_stream$Readable) {
  "use strict";

  _inherits(FileStream, _stream$Readable);

  var _super = _createSuper(FileStream);

  function FileStream(file, opts) {
    var _this;

    _classCallCheck(this, FileStream);

    _this = _super.call(this, opts);
    _this.destroyed = false;
    _this._torrent = file._torrent;
    var start = opts && opts.start || 0;
    var end = opts && opts.end && opts.end < file.length ? opts.end : file.length - 1;
    var pieceLength = file._torrent.pieceLength;
    _this._startPiece = (start + file.offset) / pieceLength | 0;
    _this._endPiece = (end + file.offset) / pieceLength | 0;
    _this._piece = _this._startPiece;
    _this._offset = start + file.offset - _this._startPiece * pieceLength;
    _this._missing = end - start + 1;
    _this._reading = false;
    _this._notifying = false;
    _this._criticalLength = Math.min(1024 * 1024 / pieceLength | 0, 2);
    return _this;
  }

  _createClass(FileStream, [{
    key: "_read",
    value: function _read() {
      if (this._reading) return;
      this._reading = true;

      this._notify();
    }
  }, {
    key: "_notify",
    value: function _notify() {
      var _this2 = this;

      if (!this._reading || this._missing === 0) return;

      if (!this._torrent.bitfield.get(this._piece)) {
        return this._torrent.critical(this._piece, this._piece + this._criticalLength);
      }

      if (this._notifying) return;
      this._notifying = true;
      if (this._torrent.destroyed) return this._destroy(new Error('Torrent removed'));
      var p = this._piece;

      this._torrent.store.get(p, function (err, buffer) {
        _this2._notifying = false;
        if (_this2.destroyed) return;
        debug('read %s (length %s) (err %s)', p, buffer.length, err && err.message);
        if (err) return _this2._destroy(err);

        if (_this2._offset) {
          buffer = buffer.slice(_this2._offset);
          _this2._offset = 0;
        }

        if (_this2._missing < buffer.length) {
          buffer = buffer.slice(0, _this2._missing);
        }

        _this2._missing -= buffer.length;
        debug('pushing buffer of length %s', buffer.length);
        _this2._reading = false;

        _this2.push(buffer);

        if (_this2._missing === 0) _this2.push(null);
      });

      this._piece += 1;
    }
  }, {
    key: "destroy",
    value: function destroy(onclose) {
      this._destroy(null, onclose);
    }
  }, {
    key: "_destroy",
    value: function _destroy(err, onclose) {
      if (this.destroyed) return;
      this.destroyed = true;

      if (!this._torrent.destroyed) {
        this._torrent.deselect(this._startPiece, this._endPiece, true);
      }

      if (err) this.emit('error', err);
      this.emit('close');
      if (onclose) onclose();
    }
  }]);

  return FileStream;
}(stream.Readable);

module.exports = FileStream;